module.exports = __webpack_public_path__ + "static/media/archero2_page_area04_img_en@2x.478a7146.jpg";